import Model, { attr, hasMany } from '@ember-data/model';
import type { SyncHasMany } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

import type AccessEventModel from './access-event';

@adapter('person-access-event-group')
class PersonAccessEventGroupModel extends Model {
  @attr('number') declare count: number;
  @attr('array') declare integrationTypes: string[];
  @attr('string') declare timeRange: string;

  @hasMany('access-event', { async: false, inverse: null }) declare result: SyncHasMany<AccessEventModel>;
}

export default PersonAccessEventGroupModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'person-access-event-group': PersonAccessEventGroupModel;
  }
}
